module.exports = __webpack_public_path__ + "img/141.84769408.png";